<template>
	<div>
		<section>
			<h2>{{ $t('MAIN_CONTENT.StudentDataForms.formsAwaitingCompletionTitleCase') }}</h2>
			<template v-if="Object.keys(message).length > 0">
				<br />
				<div class="row" style="margin-left: 0; margin-right: 0;">
					<div class="col-xs-12 alert alert-info"
								:class="{'alert-success': message.TYPE === 'success', 'alert-danger': message.TYPE === 'error'}">
						{{ message.TEXT }}
					</div>
				</div>
			</template>
			<template v-if="oneTimeForms.length === 0">
				{{ $t('MAIN_CONTENT.StudentDataForms.noFormsAwaitingCompletion') }}
			</template>
			<div class="table-responsive">
				<!-- Start of One Time Forms -->
				<table-editable-list :columns="oneTimeColumns"
														 :headerClasses="'th-left'"
															:show-select="false"
															:show-actions="true"
															:actionsHeader="$t( 'MAIN_CONTENT.CourseRequestForms.actions' )"
															v-if="oneTimeForms.length > 0">
					<template slot="data-row">
						<template v-for="(form, studentDataFormsIdx) in oneTimeForms">
							<table-list-row :key="`studentDataForms-${ studentDataFormsIdx }`"
															:columns="oneTimeColumns"
															:rowdata="form"
															:useAnchor="false"
															:rowIndex="studentDataFormsIdx">
								<template slot="actions">
									<td class="text-center">
										<button class="btn btn-unstyled btn-md"
														v-if="form.FORM_STATUS_FLG === 'O'"
														@click="deleteSavedForm(form)">
											<font-awesome-icon icon="undo" aria-hidden="true">
											</font-awesome-icon> <span class="sr-only">
												{{ $t('MAIN_CONTENT.StudentDataForms.resetFormTitleCase') }}
											</span>
											{{ $t('MAIN_CONTENT.StudentDataForms.resetFormTitleCase') }}
										</button>
										
									</td>
								</template>
							</table-list-row>
						</template>
					</template>
				</table-editable-list>
				<!-- End of One Time Forms -->

				<h2>{{ $t('MAIN_CONTENT.StudentDataForms.onDemandFormsTitleCase') }}</h2>
				<!-- Start of On Demand Forms -->
				<table-editable-list :columns="onDemandColumns"
														  :headerClasses="'th-left'"
															:show-select="false"
															:show-actions="false">
					<template slot="data-row">
						<template v-for="(form, studentDataFormsIdx) in onDemandForms">
							<table-list-row :key="`studentDataForms-${ studentDataFormsIdx }`"
															:columns="onDemandColumns"
															:rowdata="form"
															:useAnchor="false"
															:showActions="false"
															:rowIndex="studentDataFormsIdx">
							</table-list-row>
						</template>
					</template>
				</table-editable-list>
				<!-- End of On Demand Forms -->
				<h2>{{ $t('MAIN_CONTENT.StudentDataForms.submittedFormLabel') }}</h2>
				<table class="table table-striped" v-if="!!recentForms.PENDINGFORMS && recentForms.PENDINGFORMS.length>0">
						<thead>
							<tr>
								<th class="text-left">{{ $t('MAIN_CONTENT.StudentDataForms.pendingFormLabel') }}</th>
								<th class="text-right">{{ $t('MAIN_CONTENT.StudentDataForms.submittedTitleCase') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(form, idx) in recentForms.PENDINGFORMS"
									:key="`data_verification_forms_${idx}`">
								<template v-if="((role === 'student' && form.STUDENT_ACCESS_FLG === 'Y') || role === 'parent' && form.PARENT_ACCESS_FLG === 'Y')">
									<td>
										<a href="#" @click.prevent="goToForm(form)">
											{{form.DV_FORM_NAME}}
										</a>
										<p v-if="form.DV_FORM_NAME !== form.DV_FORM_DESC" class="text-muted">{{form.DV_FORM_DESC}}</p>
									</td>
									<td class="text-right">{{form.SUBMITTED_DATE | datetime('MMMM, DD YYYY HH:mm:ss', 'MM/DD/YYYY h:mm a')}}</td>
								</template>
							</tr>
						</tbody>
					</table>

					<table class="table table-striped">
						<thead>
							<tr>
								<th class="col-sm-2 text-left" style="white-space:nowrap;">
									{{ $t( 'MAIN_CONTENT.StudentDataForms.recentFormLabel' ) }}
								</th>
								<th class="col-sm-2 text-left">
									<div class="input-group input-group-sm">
										<span class="input-group-addon">{{ $t( 'MAIN_CONTENT.StudentDataForms.lastTitleCase' ) }}</span>
										<input type="number" min="1" class="form-control" max="200" @click="searchTimeOut()" @keyup="searchTimeOut()" @change="searchTimeOut()" v-model="days">
										<span class="input-group-addon text-nowrap">{{ $t( 'MAIN_CONTENT.StudentDataForms.daysTitleCase' ) }} <small v-if="loading" class="text-nowrap"><i class="fas fa-spinner fa-spin"></i></small></span>
									</div>
								</th>
								<th class="text-right">{{ $t( 'MAIN_CONTENT.StudentDataForms.completedTitleCase' ) }}</th>
								<th class="text-right">{{ $t( 'MAIN_CONTENT.StudentDataForms.status' ) }}</th>
							</tr>
						</thead>
						<tbody v-if="!!recentForms.RECENTLY_COMPLETED_FORMS && recentForms.RECENTLY_COMPLETED_FORMS.length>0">
							<tr v-for="(form, idx) in recentForms.RECENTLY_COMPLETED_FORMS"
									:key="`data_verification_forms_${idx}`">
								<template v-if="((role === 'student' && form.STUDENT_ACCESS_FLG === 'Y') || role === 'parent' && form.PARENT_ACCESS_FLG === 'Y')">
									<td colspan="2">
										<a href="#" @click.prevent="goToForm(form)">
											{{form.DV_FORM_NAME}}
										</a>
										<p v-if="form.DV_FORM_NAME !== form.DV_FORM_DESC" class="text-muted">{{form.DV_FORM_DESC}}</p>
									</td>
									<td class="text-right">{{form.MODIFIED_DATE | date('MMMM, DD YYYY', 'MM/DD/YYYY')}}</td>
									<td class="text-right">
										{{form.FORM_STATUS_FLG == "A" ? $t( 'MAIN_CONTENT.StudentDataForms.approvedTitleCase' ):$t( 'MAIN_CONTENT.StudentDataForms.declinedTitleCase' )}}
									</td>
								</template>
							</tr>
						</tbody>
						<tbody v-else>
							<tr><td colspan="4">{{$t( 'MAIN_CONTENT.StudentDataForms.resultsMessageText' )}}</td></tr>
						</tbody>
					</table>
			</div>
		</section>
	</div>
</template>

<script>
	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
	import moment from 'moment';
	import { mapGetters } from 'vuex';

	import StudentDataForms from '../api/StudentDataForms.js';

	export default {
		data() {
			return {
				isLoading: {
					settings: false
				},
				selectedColumns:	[],
				showHideColumns:	[],
				showNonGrade:		false,
				sortOrders:			{},
				message:			{},
				tableData:			[],
				oneTimeForms:		[],
				onDemandForms:		[],
				recentForms:		[],
				days:				30,
				timer:				null,
				loading:			true,
				formTypes: [
					{ id: "03", name: "Forms Awaiting Completion" },
					{ id: "04", name: "OnDemand Forms" }
				],
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules', 'role']),
			oneTimeColumns() {
				return [
					{
						customColumn: 'form',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.formLabel'),
						key: 'DV_FORM_NAME',
						type: 'link',
						link: 'LINK'
					},
					{
						customColumn: 'description',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.descriptionLabel'),
						key: 'DV_FORM_DESC'
					},
					{
						customColumn: 'status',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.status'),
						key: 'STATUS'
					},
					{
						customColumn: 'closeTime',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.openUntilTitleCase'),
						key: 'DV_FORM_END_DT_DISPLAY'
					}
				];
			},
			onDemandColumns() {
				return [
					{
						customColumn: 'form',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.formLabel'),
						key: 'DV_FORM_NAME',
						type: 'link',
						link: 'LINK'
					},
					{
						customColumn: 'description',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.descriptionLabel'),
						key: 'DV_FORM_DESC'
					},
					{
						customColumn: 'status',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.status'),
						key: 'STATUS'
					},
					{
						customColumn: 'closeTime',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.openUntilTitleCase'),
						key: 'DV_FORM_END_DT_DISPLAY'
					},
					{
						customColumn: 'submissionCount',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.submissionsTitleCase'),
						key: 'SUBMISSION_COUNT'
					},
					{
						customColumn: 'lastSubmission',
						heading: this.$t('MAIN_CONTENT.StudentDataForms.lastSubmittedTitleCase'),
						key: 'LAST_SUBMITTED_DATE'
					 }
				];
			}
		},
		components: {
			TableEditableList,
			TableListRow,
			FontAwesomeIcon
		},
		methods: {
			searchTimeOut() {  
				this.loading = true;
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
				this.timer = setTimeout(() => {
					this.loadPendingAndRecentForms()
				}, 800);
			},
			goToForm(form) {
				this.$router.push({
					name: form.FORM_TYPE == 'S' ? 'OneTimeForm' : 'OnDemandForm',
					params: {
						formID: form.DV_FORM_ID,
						instanceID: form.INSTANCE_ID
					},
					query: {
						referrer: 'StudentDataForms',
						formStatus: form.FORM_STATUS_FLG
					},
				});
			},
			loadPendingAndRecentForms() {
				const self = this;

				let forms = new StudentDataForms({
					routeParams: { setting: 'recent-forms' },
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						recently_completed_days: self.days
					}
				});

				const promise = forms.get();

				promise.then(response => {
					self.$set(self, 'recentForms', forms.getResponseData());
					self.recentForms.RECENTLY_COMPLETED_FORMS.sort(
						( a, b ) => ( moment( a.MODIFIED_DATE ) < moment( b.MODIFIED_DATE ) ) ? 1 : -1
					);
					self.recentForms.PENDINGFORMS.sort(
						( a, b ) => ( moment( a.SUBMITTED_DATE ) < moment( b.SUBMITTED_DATE ) ) ? 1 : -1
					);
					self.loading = false;
				});
			},
			loadOneTimeForms() {
				const self = this;

				let forms = new StudentDataForms({
					routeParams: { setting: 'one-time-forms' },
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						form_status_flg: 'N,O',
						dv_form_type:'S'
					}
				});

				const promise = forms.get();

				promise.then(response => {
					let displayData = [];

					for(let f in forms.getResponseData()) {
						let form = forms.getResponseData()[f];

						form.STATUS = form.FORM_STATUS_FLG === 'O' ?
							'Started' : 'Open';

						form.DV_FORM_BEG_DT_DISPLAY = self.$options.filters.datetime(form.DV_FORM_BEG_DT);
						form.DV_FORM_END_DT_DISPLAY = self.$options.filters.datetime(form.DV_FORM_END_DT);
						form.LINK = `/one-time-form/form/${form.DV_FORM_ID}/ins/${form.INSTANCE_ID}?formStatus=${form.FORM_STATUS_FLG}`;

						displayData.push(form);
					}

					self.$set(self, 'oneTimeForms', displayData);
					self.loadOnDemandForms();
				});
			},
			loadOnDemandForms() {
				const self = this;

				let forms = new StudentDataForms({
					routeParams: { setting: 'on-demand-forms' },
					query: {
						student_rid: self.selectedStudent.STUDENT_RID
					}
				});

				const promise = forms.get();

				promise.then(response => {
					let displayData = [];

					for(let f in forms.getResponseData()) {
						let form = forms.getResponseData()[f];

						form.STATUS = form.FORM_STATUS_FLG === 'O' ?
							'Started' : 'Open';

						form.DV_FORM_BEG_DT_DISPLAY = self.$options.filters.datetime(form.DV_FORM_BEG_DT);
						form.DV_FORM_END_DT_DISPLAY = self.$options.filters.datetime(form.DV_FORM_END_DT);
						form.LINK = `/on-demand-form/form/${form.DV_FORM_ID}/ins/${form.INSTANCE_ID}?formStatus=${form.FORM_STATUS_FLG}`;

						displayData.push(form);
					}

					self.$set(self, 'onDemandForms', displayData);
				});
			},
			setHeadings() {
				// One time forms
				this.oneTimeColumns[0].heading = this.$t('MAIN_CONTENT.StudentDataForms.formLabel');
				this.oneTimeColumns[1].heading = this.$t('MAIN_CONTENT.StudentDataForms.descriptionLabel');
				this.oneTimeColumns[2].heading = this.$t('MAIN_CONTENT.StudentDataForms.status');
				this.oneTimeColumns[3].heading = this.$t('MAIN_CONTENT.StudentDataForms.openUntilTitleCase');

				// On demand forms
				this.onDemandColumns[0].heading = this.$t('MAIN_CONTENT.StudentDataForms.formLabel');
				this.onDemandColumns[1].heading = this.$t('MAIN_CONTENT.StudentDataForms.descriptionLabel');
				this.onDemandColumns[2].heading = this.$t('MAIN_CONTENT.StudentDataForms.status');
				this.onDemandColumns[3].heading = this.$t('MAIN_CONTENT.StudentDataForms.openUntilTitleCase');
				this.onDemandColumns[5].heading = this.$t('MAIN_CONTENT.StudentDataForms.submissionsTitleCase');
				this.onDemandColumns[5].heading = this.$t('MAIN_CONTENT.StudentDataForms.lastSubmittedTitleCase');
			},
			deleteSavedForm(form) {
				const self = this;

				const msg = this.$t( 'MAIN_CONTENT.StudentDataForms.deleteFormMessage' );
				const title = this.$t( 'MAIN_CONTENT.StudentDataForms.deleteFormTitle' );
				const okTxt = this.$t( 'MAIN_CONTENT.StudentDataForms.deleteFormOkText' );
				const cancelTxt = this.$t('commonText.cancel');

				this.$modal.confirm(msg, { title: title, okText: okTxt, cancelText: cancelTxt}).then(ans => {
					if( ans ){

						let forms = new StudentDataForms({
							routeParams: { setting: 'form' },
							query: {
								student_rid: self.selectedStudent.STUDENT_RID,
								dv_form_id: form.DV_FORM_ID,
								instance_id: form.INSTANCE_ID
							}
						});

						const promise = forms.delete();

						promise.then(response => {
							if(forms.getResponseData().TYPE === 'success') {
								self.$set(self, 'message', forms.getResponseData());
								self.loadOneTimeForms();
							}
						});
					}
				});
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'clipboard');
			this.$store.commit('setTitle', 'MAIN_CONTENT.StudentDataForms.sideMenuStudentDataFormsLink');
			this.$store.commit('setUseHeader', true);
			this.setHeadings();
			this.loadOneTimeForms();
			this.loadPendingAndRecentForms();
		}
	}
</script>
